export default __webpack_public_path__ + "static/media/rocket_anim_60.4d32a86b.png";